import { PublicClientApplication, BrowserCacheLocation, LogLevel, InteractionType } from '@azure/msal-browser';
import { MSAL_INSTANCE, MsalGuardConfiguration, MSAL_GUARD_CONFIG, MsalInterceptorConfiguration, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { InjectionToken } from '@angular/core';
import { env } from '../../../environments/environment';
import { endWith } from 'rxjs';

export function MSALInstanceFactory(): PublicClientApplication {  
  return new PublicClientApplication({
    auth: {
      clientId: env.clientId, // Replace with your Azure AD Client ID
      authority: env.authority, // Replace with your Tenant ID
      redirectUri: env.redirectUri // Replace with your redirect URI'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message) => {
          console.log(message);
        },
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALGuardConfigurationFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  var Grpah_Ql= env.graphQlUrl;
  protectedResourceMap.set('/graphql/', [Grpah_Ql, 'user.read']);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export const provideMSAL = (instanceFactory: () => PublicClientApplication, guardConfigFactory: () => MsalGuardConfiguration, interceptorConfigFactory:()=>MsalInterceptorConfiguration) => [
  { provide: MSAL_INSTANCE, useFactory: instanceFactory },
  { provide: MSAL_GUARD_CONFIG, useFactory: guardConfigFactory },
  { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: interceptorConfigFactory }
];